import { autoinject } from 'aurelia-framework';
import { DrilldownCommonModel } from '~/components/dialog/dialog-with-tabs/drilldown-model';
import { ATOInterfacesModel } from '~/forms/ato-interfaces/models/ato-interfaces-model';
import { ColumnDefinitionMap } from '~/models/column-definition';

@autoinject
export class SummaryTab extends DrilldownCommonModel {
	private showEventItems: boolean = false;

	constructor(
		template: string,
		data: ATOInterfacesModel,
		tableColumnDefinitions: ColumnDefinitionMap,
	) {
		super(template, data, tableColumnDefinitions);
	}

	public toggleEventItems() {
		this.showEventItems = !this.showEventItems;
	}
}
